<template>
  <v-card class="mt-4">
    <v-list-item class="py-2">
      <v-list-item-avatar>
        <v-avatar color="cyan">
          <v-icon color="white"> fal fa-camera-alt </v-icon>
        </v-avatar>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title>
          <h6 class="title text-truncate">
            <Dictionary module="permissions" string="photo_permission_title" />
          </h6>
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ clubName }}
          <v-dialog v-model="dialog" width="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn text small v-bind="attrs" v-on="on" class="ml-0" icon>
                <v-icon size="small">fal fa-info-circle</v-icon>
              </v-btn>
            </template>

            <v-card>
              <v-card-title class="text-h5 cyan text--white">
                <Dictionary
                  module="permissions"
                  string="photo_permission_title"
                />
              </v-card-title>

              <v-card-text class="mt-2">
                <Dictionary
                  module="permissions"
                  string="photo_permission_explanation"
                />

                <div class="text-center">
                  <span class="fa-stack">
                    <i class="fas fa-camera fa-stack-1x"></i>
                    <i class="fa fa-ban fa-stack-2x UIAction--text"></i>
                  </span>
                </div>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="dialog = false">
                  Got it
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action>
        <ChildrenPermissionList :permissions="clientPermission.permissions" />
      </v-list-item-action>
    </v-list-item>
  </v-card>
</template>
<script>
import ChildrenPermissionList from './ChildrenPermissionList';
export default {
  name: 'ClientPhotoPermissionListItem',
  data() {
    return {
      dialog: false,
    };
  },
  props: {
    clientPermission: {
      required: true,
      type: Object,
    },
  },

  computed: {
    clubName() {
      const { clientPermission } = this;
      return clientPermission.clubName;
    },
    permissions() {
      return clientPermission.permissions;
    },
  },
  components: {
    ChildrenPermissionList,
  },
};
</script>
